import * as React from 'react';
import { Box, ButtonBase, Card, CardContent, CardMedia, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';

import { IBuildingItem } from 'models';

interface BuildingItemGridModeProps {
  building: IBuildingItem;
  onBuildingItem?: (buildingId: number) => void;
}

export const BuildingItemGridMode: React.FC<BuildingItemGridModeProps> = (props) => {
  const theme = useTheme();
  const { building, onBuildingItem = () => {} } = props;

  return (
    <ButtonBase
      sx={{
        width: '100%',
        maxWidth: 345,
        display: 'block',
        textAlign: 'left',
        cursor: 'pointer',
        borderRadius: 1,
        border: `2px solid transparent`,
        '&:hover': {
          borderColor: theme.palette.primary.light,
        },
      }}
      onClick={() => {
        onBuildingItem(building.id);
      }}
    >
      <Card sx={{ width: '100%', position: 'relative' }} className="building-card">
        <React.Suspense fallback={<Box sx={{ width: 40, height: 40, bgcolor: 'red' }} />}>
          <CardMedia component="img" height="140" image={building.thumbnail} className="building-card-media" />
        </React.Suspense>

        <CardContent>
          <Typography variant="caption" color="primary" sx={{ fontWeight: '700' }}>
            {building.floors > 0 ? `${building.floors} FLOOR${building.floors > 1 ? 'S' : ''}` : <>&nbsp;</>}
          </Typography>

          <Typography variant="subtitle1" noWrap sx={{ fontSize: '1.125rem' }}>
            {building.location}
          </Typography>

          <Box>
            <Typography variant="caption" color="textSecondary">
              Date Created{' ⋅ '}
            </Typography>

            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: '700' }}>
              {dayjs(building.created_at).format('MM/DD/YYYY')}
            </Typography>

            <Typography variant="caption" color="textSecondary">
              &nbsp;&nbsp;{'|'}&nbsp;&nbsp;Floors{' ⋅ '}
            </Typography>

            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: '700' }}>
              {building.floors}
            </Typography>
          </Box>

          <Box sx={{ position: 'absolute', top: 12, right: 12 }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                top: 0,
                left: 0,
                background: `linear-gradient(-45deg, rgba(255,137,0,1) 0%, rgba(255,137,0,1) 50%, rgba(255,169,34,1) 50%, rgba(255,169,34,1) 100%)`,
                width: 30,
                height: 30,
                borderRadius: 0.5,
              }}
            >
              <Typography>{building.zones}</Typography>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </ButtonBase>
  );
};
